import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';

export enum ModalType {
  FullScreen = 1,
  Medium = 2,
  Small = 3,
  Half = 4,
  Large = 5
}

export interface ModalOptions {
  modalType: ModalType ;
  disableClose?: boolean;
  initialTab?: number,
  data?: any;
}


@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private _currentDialog!: MatDialogRef<any>;

  constructor(
    private dialog: MatDialog,
  ) {}

  open(component: any, modalOptions: ModalOptions, afterClosed?: (result: any) => void) {
    this.closeAll(); // we only want one modal open at a time
    const modalType = modalOptions.modalType;
    const initialTab = modalOptions.initialTab;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;

  
    dialogConfig.data = {
      ...modalOptions.data,
      initialTab: initialTab
    };
    
    dialogConfig.disableClose = modalOptions.disableClose;

    if (modalType === ModalType.FullScreen) {
      dialogConfig.panelClass = 'full-screen-modal-panel-class';
    }

    if (modalType === ModalType.Medium) {
      dialogConfig.panelClass = 'medium-modal-panel-class';
    }

    if (modalType === ModalType.Small) {
      dialogConfig.panelClass = 'small-modal-panel-class';
    }

    if (modalType === ModalType.Half) {
      dialogConfig.panelClass = 'half-modal-panel-class';
    }

    if (modalType === ModalType.Large) {
      dialogConfig.panelClass = 'large-modal-panel-class';
    }

    this._currentDialog = this.dialog.open(component, dialogConfig);

    if (afterClosed) {
      this._currentDialog
        .afterClosed()
        .pipe(take(1))
        .subscribe((result: any) => {
          afterClosed(result);
        });
    }
  }

  close() {
    this._currentDialog.close();
  }

  closeAll() {
    this.dialog.closeAll();
  }


}
